import { ChevronRightIcon } from '@heroicons/react/24/outline'
import React from 'react'
import { ButtonLink } from './ButtonLink'
import Image, { StaticImageData } from 'next/image'
import { bookDemoLink, signupLink } from '@/config'

interface Feature {
  name: string
  heading: string
  description: string
  image: StaticImageData
}

function FeaturesHero({ feature }: { feature: Feature }) {
  return (
    <section className="flex w-full flex-col items-center gap-40 px-5 py-20 sm:px-10 lg:px-[100px] lg:py-[112px] xl:mt-0 xl:gap-[224px]">
      <div
        className={`flex w-full max-w-[1240px] flex-col items-center justify-center gap-[60px] xl:flex-row xl:justify-between xl:gap-20`}
      >
        <div className="flex w-full flex-col items-center justify-center px-0 xl:w-[560px] xl:items-start">
          <h5 className="font-robotoMono text-xs font-medium uppercase leading-[100%] tracking-[1.2px] text-[#38BDF9]">
            {feature.name}
          </h5>
          <h3 className="mt-4 w-full text-center text-[36px] font-medium leading-[130%] tracking-[-0.36px] lg:w-[560px] xl:text-left xl:text-[48px] xl:tracking-[-0.48px]">
            {feature.heading}
          </h3>
          <p className="mt-4 w-full text-center text-base !leading-[150%] tracking-[-0.16px] text-white/80 lg:w-[444px] xl:mt-5 xl:text-left xl:text-lg xl:tracking-[-0.18px]">
            {feature.description}
          </p>

          <div className="custom-xs:flex-row mt-10 flex flex-col items-center gap-4 xl:items-start">
            <ButtonLink
              target="_blank"
              href={bookDemoLink}
              variant="primary"
              size="lg"
              className="rounded-xl"
              aria-label="Book a Demo"
            >
              Book a Demo
            </ButtonLink>

            <ButtonLink href={signupLink} size="lg">
              <span className="text-base">Start Free Trial</span>
              <ChevronRightIcon className="-ml-1 h-3 w-3 stroke-2 text-white transition-colors duration-300 group-hover:text-[#38BDF9]" />
            </ButtonLink>
          </div>
        </div>

        <Image src={feature.image} alt="asset cost" className="w-[600px]" />
      </div>
    </section>
  )
}

export default FeaturesHero
